import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { WellCatImportOptions, WellCatImportResult } from '../models/well-cat.models';

const PeriforApiEndpoint = `${environment.PeriforEndpoint}/api`;

@Injectable({
  providedIn: 'root'
})
export class WellCatService {
  constructor(private readonly http: HttpClient) {}

  importFromFile(file: File, options: WellCatImportOptions): Observable<WellCatImportResult> {
    const formData = new FormData();
    formData.append('file', file);
    formData.append('importTrajectory', String(options.importTrajectory));
    formData.append('importWellboreGeometry', String(options.importWellboreGeometry));
    formData.append('importFormationMarkers', String(options.importFormationMarkers));
    formData.append('importPressureWindow', String(options.importPressureWindow));
    formData.append('importTemperature', String(options.importTemperature));

    return this.http.post<WellCatImportResult>(`${PeriforApiEndpoint}/wellcat/import`, formData);
  }
}
